import {UpdateRecordAuditHeaderRequestBody} from '@dms/api/core';
import {RecordIdHttpModel} from '@dms/api/shared';

import {RecordAuditMetadataFormValue} from './recordAuditMetadataFormSchema';
import {toRecordAuditHeaderFields} from './toRecordAuditHeaderFields';

export const toUpdateRecordAuditHeaderBody = (args: {
  values: RecordAuditMetadataFormValue;
  pairedRecord: RecordIdHttpModel | null;
}): UpdateRecordAuditHeaderRequestBody => toRecordAuditHeaderFields(args.values, args.pairedRecord);
